import React, { useState } from 'react';
import { simboloMoneda } from '../services/negocioActual';
import { linkProductoOG, linkWhatsAppA, linkInstagramDM, copiarTexto } from '../utils/compartir';
import { precioEfectivo, enOferta } from '../utils/precios';
import { origenActual, etiquetaOrigen } from '../utils/origenCatalogo';
import { eventoPixel, datosProducto } from '../utils/metaPixel';

// Botones de contacto para UN producto en el catálogo. Así la clienta elige
// por dónde hacer su pedido: WhatsApp o Instagram.
// - WhatsApp: abre DIRECTO el chat con la tienda y el mensaje ya escrito.
// - Instagram: NO permite prellenar el mensaje. Copiamos el producto y mostramos
//   una ventanita con instrucciones (para que a la clienta le dé tiempo de leer);
//   al tocar "Abrir Instagram" se abre el chat y ella solo pega el mensaje.
// Ambos navegan en la MISMA pestaña para que, al volver, la clienta siga en el
// catálogo (con pestaña nueva "se perdía" la página).
export default function BotonesCompartirProducto({ negocioId, producto, negocioTelefono = '', negocioNombre = '', negocioInstagram = '', moneda }) {
  const [igAbierto, setIgAbierto] = useState(false);
  const url = linkProductoOG({ negocioId, productoId: producto.id });
  const dmLink = linkInstagramDM(negocioInstagram);

  // Mensaje que le llega a la tienda cuando la clienta escribe por este producto.
  // Si el producto está en oferta, muestra el precio con descuento (el que se
  // cobra) e indica el precio anterior, para que clienta y tienda vean lo mismo.
  const precioTxt = enOferta(producto)
    ? `${simboloMoneda()} ${precioEfectivo(producto)} 🔥 (en oferta, antes ${simboloMoneda()} ${producto.precio_venta})`
    : `${simboloMoneda()} ${producto.precio_venta}`;
  // Si llegó por un enlace con origen (historia, bio…), la tienda lo ve en el mensaje.
  const origen = origenActual();
  const mensajeTienda =
    `¡Hola ${negocioNombre || 'tienda'}! 🛍️ Me interesa este producto:\n` +
    `${producto.nombre} — ${precioTxt}\n${url}` +
    (origen ? `\n(Vi el catálogo desde: ${etiquetaOrigen(origen).etiqueta})` : '');

  // Tocar WhatsApp/Instagram es la intención de compra real: se avisa al píxel
  // como AddToCart ("Tocaron Comprar") para que los anuncios de Ventas aprendan.
  const avisarPixel = (canal) => eventoPixel('AddToCart', { ...datosProducto(producto, precioEfectivo(producto), moneda), canal });

  const escribirTienda = () => {
    avisarPixel('whatsapp');
    const link = negocioTelefono
      ? linkWhatsAppA(negocioTelefono, mensajeTienda)
      : `https://api.whatsapp.com/send?text=${encodeURIComponent(mensajeTienda)}`;
    window.location.href = link; // misma pestaña
  };

  const escribirInstagram = async () => {
    avisarPixel('instagram');
    if (!dmLink) { window.location.href = 'https://www.instagram.com/'; return; }
    // Copiamos el producto AHORA (dentro del toque) para que el portapapeles
    // quede listo, y mostramos las instrucciones sin apuro.
    try { await copiarTexto(mensajeTienda); } catch (e) { /* igual mostramos las instrucciones */ }
    setIgAbierto(true);
  };

  const btn = (bg) => ({
    flex: 1, padding: '7px 0', border: 'none', borderRadius: '8px', backgroundColor: bg,
    color: 'white', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px',
  });

  const stop = (fn) => (e) => { e.stopPropagation(); fn(); };

  return (
    <div style={{ display: 'flex', gap: '6px', marginTop: '8px' }}>
      <button title="Escríbenos por WhatsApp sobre este producto"
        onClick={stop(escribirTienda)} style={btn('#25D366')}>💬 WhatsApp</button>
      <button title="Escríbenos por Instagram sobre este producto"
        onClick={stop(escribirInstagram)} style={btn('#E1306C')}>📷 Instagram</button>

      {igAbierto && (
        <div onClick={(e) => { e.stopPropagation(); setIgAbierto(false); }}
          style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px', zIndex: 2000 }}>
          <div onClick={(e) => e.stopPropagation()}
            style={{ backgroundColor: 'white', borderRadius: '18px', maxWidth: '360px', width: '100%', padding: '24px', textAlign: 'center', boxShadow: '0 8px 32px rgba(0,0,0,0.25)' }}>
            <div style={{ fontSize: '40px', marginBottom: '6px' }}>📋✅</div>
            <h3 style={{ margin: '0 0 10px', fontSize: '19px', color: '#111827' }}>¡Producto copiado!</h3>
            <p style={{ margin: '0 0 6px', fontSize: '14px', color: '#374151', lineHeight: 1.55 }}>
              Ya copiamos este producto. Cuando se abra Instagram:
            </p>
            <ol style={{ margin: '0 0 18px', padding: '0 0 0 20px', textAlign: 'left', fontSize: '14px', color: '#374151', lineHeight: 1.7 }}>
              <li>Mantén presionado el campo de mensaje ✍️</li>
              <li>Toca <b>“Pegar”</b> 📋</li>
              <li>Toca <b>Enviar</b> 💜</li>
            </ol>
            <button onClick={() => { setIgAbierto(false); window.location.href = dmLink; }}
              style={{ width: '100%', padding: '14px', backgroundColor: '#E1306C', color: 'white', border: 'none', borderRadius: '12px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', marginBottom: '8px' }}>
              📷 Abrir Instagram y pegar
            </button>
            <button onClick={() => setIgAbierto(false)}
              style={{ width: '100%', padding: '9px', background: 'none', border: 'none', color: '#9CA3AF', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }}>
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
